<template>
    <Card title="新增菜单">
    <div>
<!--        <Modal v-if="visible" v-model="visible"-->
<!--               contentWidth="800px"-->
<!--               :visible="visible" :title="'新增菜单'" :showFooter="false" :overlayOpacity="0.5" @update:visible="visible = $event">-->
            <a-form :form="form" @submit="handleSubmit" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" :colon="false" >
                <a-row>
                    <a-col :lg="12" :md="12" :sm="24">
                        <InputField required labelWidth="20%" style="margin: 0.5rem 0.5rem;width:90%;padding-left: 1rem;" label="姓名" type="text" id="name" v-model="form.name" placeholder="请输入姓名"/>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <InputField required labelWidth="35%" style="margin: 0.5rem 0.5rem;width:90%;" label="路径" type="text" id="mobile" v-model="form.mobile" placeholder="请输入路径"/>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <CascaderField
                            labelWidth="20%"
                            cascaderWidth="72%"
                            label="上级菜单"
                            placeholder="请选择菜单"
                            :decorator="['pid']"
                            :options="menuList"
                            :fieldNames="{
                                label: 'name',
                                value: 'id',
                                children: 'children',
                              }"
                            @change="handleCascaderChange"/>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <SelectField labelWidth="35%" style="margin: 0.5rem 0.5rem;width:90%;" :options="permissionList" v-model="form.permission" label="权限" id="permission" required placeholder="请选择权限"/>
                    </a-col>
                </a-row>
                    <a-col :lg="12" :md="12" :sm="24">
                         <RadioField style="width:90%;padding-left: 1rem;" labelWidth="20%" name="type" label="类型" required :options="menuTypeList"  v-model="form.type"/>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                         <RadioField style="width:90%;" labelWidth="20%" name="type" label="状态" required :options="statusList"  v-model="form.status"/>
                    </a-col>
                <a-row>
                    <a-col :lg="12" :md="12" :sm="24">
                        <InputField required labelWidth="20%" style="margin: 0.5rem 0.5rem;width:90%;padding-left: 1rem;" label="排序" type="number" id="sort" v-model="form.sort" placeholder="请输入排序"/>
                    </a-col>
                    <a-col :lg="12" :md="12" :sm="24">
                        <RadioField style="width:90%;" labelWidth="20%" name="type" label="平台" required :options="platformList"  v-model="form.platform"/>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :lg="24" :md="24" :sm="24">
                        <InputField required labelWidth="10%" style="margin: 0.5rem 0.5rem;width:90%;padding-left: 1rem;" label="描述" type="text" id="remarks" v-model="form.remarks" placeholder="请输入描述"/>
                    </a-col>
                </a-row>
                <div class="center" style="margin: 1.5rem 0">
                    <a-space>
                        <ButtonField text="关闭" @click="cancel" secondary />
                        <ButtonField text="保存" primary @click="handleSubmit"/>
                    </a-space>
                </div>
            </a-form>
<!--        </Modal>-->
    </div>
    </Card>
</template>

<script>
import { fetchList as fetchPermissionList } from "@/api/setting/permission";
import { fetchList as fetchMenuList, add } from "@/api/setting/menu";
import { mapGetters } from "vuex";
import { buildMenuTree } from "./tools";
export default {
  data() {
    return {
      visible:true,
      form: this.$form.createForm(this),
      permissionList: [],
      // menuList: [],
      platformList:[
          { name: 'PC', value: 'pc' },
          { name: 'App', value: 'app' },
      ],
      menuList: [
        {
            id: 1,
            name: "菜单1",
            children: [
                {
                    id: 11,
                    name: "子菜单1-1",
                },
                {
                    id: 12,
                    name: "子菜单1-2",
                },
            ],
        },
        {
            id: 2,
            name: "菜单2",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    statusList() {
      return this.findDataDict("status");
    },
    menuTypeList() {
      return this.findDataDict("menuType");
    },
  },

  mounted() {
    fetchPermissionList({
      pageNum: 1,
      pageSize: 1000,
    }).then((res) => {
      if (Array.isArray(res.list)) {
        this.permissionList = Object.freeze(res.list);
      }
    });

    fetchMenuList().then((res) => {
      if (Array.isArray(res)) {
        this.pureMenuList = Object.freeze(res);
        this.menuList = Object.freeze(buildMenuTree(res, "0"));
      }
    });
  },

  methods: {
      handleCascaderChange(value) {
          console.log("级联选择器的值变化了：", value);
      },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          add({
            ...values,
            pid:
              values.pid && values.pid.length > 0
                ? values.pid[values.pid.length - 1]
                : "0",
          }).then(() => {
            this.cancel();
          });
        }
      });
    },

    cancel() {
      this.$router.go(-1);
    },
  },
};
</script>